import React from "react";
import { Link } from "react-router-dom";
import MatrixBackground from "../components/MatrixBackground";

export default function MorphiusCount() {
  return (
    <MatrixBackground className="min-h-screen">
      <div className="relative z-10 min-h-screen overflow-hidden px-4 py-8 md:px-6 md:py-10">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_18%,rgba(34,211,238,0.10),transparent_22%),radial-gradient(circle_at_78%_20%,rgba(59,130,246,0.12),transparent_24%),radial-gradient(circle_at_50%_100%,rgba(8,47,73,0.28),transparent_36%)]" />

        <div className="relative mx-auto max-w-7xl">
          <div className="flex items-center justify-end gap-4 border-b border-cyan-300/12 pb-5">
            <Link
              to="/login"
              className="rounded-full border border-white/12 px-5 py-2.5 text-sm font-semibold text-white transition hover:border-cyan-300/30 hover:bg-white/5"
            >
              Back to Login
            </Link>
            <Link
              to="/book-demo?industry=retail"
              className="rounded-full bg-cyan-400 px-5 py-2.5 text-sm font-bold text-slate-950 transition hover:bg-cyan-300"
            >
              Book a Demo
            </Link>
          </div>

          <div className="mt-10 grid gap-8 lg:grid-cols-[1.02fr_.98fr] lg:items-start">
            <div className="rounded-[2rem] border border-cyan-300/12 bg-[linear-gradient(180deg,rgba(8,20,40,.84),rgba(4,13,27,.94))] p-8">
              <div className="text-xs uppercase tracking-[0.38em] text-cyan-200">inside matrixos</div>
              <h1 className="mt-4 text-4xl font-black leading-[1.02] text-white md:text-6xl">
                Morpheus Count is where <span className="text-cyan-300">smart stock counts</span> evolve next.
              </h1>
              <p className="mt-6 text-lg leading-8 text-slate-300">
                Morpheus Count is the next MatrixOS layer for stock counting. It upgrades your current Smart Count System into a cleaner, faster, more visual experience.
              </p>

              <div className="mt-8 rounded-[1.6rem] border border-cyan-300/12 bg-cyan-400/[0.04] p-6">
                <div className="text-xs uppercase tracking-[0.34em] text-cyan-200">coming soon</div>
                <div className="mt-3 text-2xl font-black text-white">What is coming next</div>
                <p className="mt-3 text-slate-300">
                  A full rebuild of SCS into MatrixOS with better validation, visual comparisons, and structured reporting.
                </p>
              </div>
            </div>

            <div className="rounded-[2rem] border border-cyan-300/12 bg-[linear-gradient(180deg,rgba(8,20,40,.84),rgba(4,13,27,.94))] p-8">
              <div className="text-xs uppercase tracking-[0.34em] text-cyan-200">status</div>
              <div className="mt-3 text-2xl font-black text-white">Coming soon inside MatrixOS</div>
              <p className="mt-3 text-slate-300">
                Morpheus Count is currently being built and will soon become the dedicated stock intelligence layer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </MatrixBackground>
  );
}
